import { FC, useState } from 'react';
import { Reservation } from '@mews-commander/data-access';
import { ActionType, TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { IconName } from '@optimus-web/icons';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { ReservationSimpleDetail } from '../../../simpleDetail/containers';
import { SIMPLE_DETAIL_GROUP, SIMPLE_DETAIL_RESERVATION } from '../../../simpleDetail/module';
import { openGroupOrAccountBillingModal } from '../../../navigation/billing';
import { openCustomerDetail } from '../../../app/actions/customer';

type PanelType = typeof SIMPLE_DETAIL_GROUP | typeof SIMPLE_DETAIL_RESERVATION;

interface ReservationDetailPanelProps {
    opened: boolean;
    onClose: () => void;
    reservation: Reservation;
}

export const ReservationDetailPanel: FC<ReservationDetailPanelProps> = ({ opened, reservation, onClose }) => {
    const [panel, setPanel] = useState<PanelType>(SIMPLE_DETAIL_RESERVATION);

    const dispatch = useCommanderThunkDispatch();

    const showGroup = () => setPanel(SIMPLE_DETAIL_GROUP);

    const showReservation = () => setPanel(SIMPLE_DETAIL_RESERVATION);

    const onCustomerClick = () => {
        if (reservation.customerId) {
            dispatch(openCustomerDetail(reservation.customerId));
        }
    };

    const onBillingClick = () => {
        if (reservation.customerId) {
            dispatch(
                openGroupOrAccountBillingModal({
                    accountId: reservation.customerId,
                    groupId: reservation.groupId,
                })
            );
        }
    };

    return (
        <ReservationSimpleDetail
            // @ts-expect-error
            withGroupDetail
            showTitle
            opened={opened}
            isReservationOverview
            mode={panel}
            resourceUse={reservation}
            onClose={onClose}
            showReservation={showReservation}
            showGroup={showGroup}
            actions={[
                {
                    type: ActionType.Custom,
                    actionId: 'profile',
                    text: <LocalizedText textKey={TextKey.Profile} />,
                    icon: IconName.Profile,
                    onClick: onCustomerClick,
                },
                {
                    type: ActionType.Custom,
                    actionId: 'billing',
                    text: <LocalizedText textKey={TextKey.Billing} />,
                    icon: IconName.PaymentReport,
                    onClick: onBillingClick,
                },
            ]}
        />
    );
};
